import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import SubventionFilter from '../../filters/SubventionFilter.jsx';
import TxnTypeFilter from '../../filters/TxnTypeFilter.jsx';
import SettledUnsettledFilter from '../../filters/settled_unsettledFilter.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(todayDate).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(todayDate).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(todayDate).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}
class ChoiceEmiTransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            subventionLists:[],
            subventionValue:'',
            subventionIDs:'',
            categoryLists:[],
            categoryValue:'',
            categoryIDs:'',
            brandLists:[],
            brandValue:'',
            brandIDs:'',
            modelLists:[],
            modelValue:'',
            modelIDs:'',
            emiSchemeLists:[],
            emiSchemeValue:'',
            emiSchemeIDs:'',
            tenureLists:[],
            tenureValue:'',
            tenureIDs:'',
            emiIssuerLists:[],
            emiIssuerValue:'',
            emiIssuerIDs:'',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            issuer_bank_list_box: true,
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            txnTypeLists: [],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            isSettledLists: [],
            isSettledIDs: '',
            isSettledValue: null,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            listOpen: false,
            headerTitle: "Select [Utid]",
            productTypeLists: [],
            productTypeIDs: '',
            productTypeValue: {value: '', label: 'All'},
            serviceTypeLists: [],
            serviceTypeIDs: '',
            serviceTypeValue: {value: '', label: 'All'},
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[]
        }
        this.close = this.close.bind(this);
        this.closeStoreList = this.closeStoreList.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidUpdate() {
        const { listOpen } = this.state;
        const { storeListOpen } = this.state;
        setTimeout(() => {
            if (listOpen) {
                window.addEventListener('click', this.close);
            } else {
                window.removeEventListener('click', this.close);
            }
            if (storeListOpen) {
                window.addEventListener('click', this.closeStoreList);
            } else {
                window.removeEventListener('click', this.closeStoreList);
            }
        }, 0);
    }
    close() {
        this.setState({
            listOpen: false,
        });
    }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        this._getAllMerchants();
        this._get_acq_banks();
        //this._get_issuing_banks();
        this._get_city();
        //this._getSubvention();
        this._getCategory();
        this._getBrand();
        this._getModel('');
        this._getEmiScheme();
        this._getTenure();
        this._getEmiIssure();
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code, false,'');
            this.get_filtered_emi_transaction_report( decoded.object_type,arrayCode,'');

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: decoded.object_code,
                search_type:'innoviti',
                productTypeLists:[
                    {value: '', label: 'All'},
                    {value: 'Total EMI', label: 'Total EMI'},
                    {value: 'True EMI', label: 'True EMI'},
                    {value: 'UniPAYNext', label: 'UniPAYNext'},
                    {value: 'Partner EMI',label: 'Partner EMI'},
                ],
                serviceTypeLists: [
                    {value: '', label: 'All'},
                    {value: 'Bank EMI',label: 'Bank EMI' },
                    {value: 'Brand EMI',label: 'Brand EMI' },
                    {value: 'Choice EMI',label: 'Choice EMI'},
                    {value: 'DC EMI',label: 'DC EMI'},
                    {value: 'Exclusive EMI',label: 'Exclusive EMI' },
                    {value: 'FREE Emi Wallet',label: 'FREE Emi Wallet' },
                ],
                search_object_code: decoded.object_code,
            })
            this.ci_utid('','','',false,'');
        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode,false,'');
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            setTimeout(function(){
                this.get_filtered_emi_transaction_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'merchant',
                productTypeLists:[
                    {value: '', label: 'All'},
                    {value: 'UniPAYNext', label: 'UniPAYNext'},
                ],
                serviceTypeLists: [
                    {value: '', label: 'All'},
                    {value: 'Bank EMI',label: 'Bank EMI' },
                    {value: 'Brand EMI',label: 'Brand EMI' },
                    {value: 'Choice EMI',label: 'Choice EMI'},
                    {value: 'DC EMI',label: 'DC EMI'},

                ],
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode,false,'');
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            setTimeout(function(){
                this.get_filtered_emi_transaction_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'chain',
                productTypeLists:[
                    {value: '', label: 'All'},
                    {value: 'UniPAYNext', label: 'UniPAYNext'},
                ],
                serviceTypeLists: [
                    {value: '', label: 'All'},
                    {value: 'Bank EMI',label: 'Bank EMI' },
                    {value: 'Brand EMI',label: 'Brand EMI' },
                    {value: 'Choice EMI',label: 'Choice EMI'},
                    {value: 'DC EMI',label: 'DC EMI'},

                ],
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData, true);
            setTimeout(function(){
                this.get_filtered_emi_transaction_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'store'
            })
        }
        else if(decoded.object_type=='Acquiring Bank') {

            this.get_merchant_by_acq(arrayCode, 'Acquirer', decoded.object_type, arrayCode);
            this.getChain(arrayCode, 'Acquirer', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'Acquirer', decoded.object_type, arrayCode, false,'');
            var acqData = [];

            arrayCode.map((value, index) => {
                acqData.push({"value": value, "label": ""})
            })
            this.change_acq_banks('Acquiring Bank', acqData);
            setTimeout(function(){
                this.get_filtered_emi_transaction_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }
        else if(decoded.object_type=='Issuing Bank') {
            var org = '';
            if(decoded.user_info.hasOwnProperty("organization")===true) {
                org = decoded.user_info.organization
            }
            var arrayIssuer = org.split(',');
            this._getAllMerchants();
            this.getChain('Innoviti', 'innoviti', 'Innoviti', 'Innoviti');
            this.getStore('Innoviti', 'innoviti', 'Innoviti', 'Innoviti',false,'');
            var issueData = [];

            arrayIssuer.map((value, index) => {
                issueData.push({"value": value, "label": ""})
            })
            this.changeEmiIssuer('Issuing Bank', issueData);
            setTimeout(function(){
                this.get_filtered_emi_transaction_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: false,
                issuer_bank_list_box: false,
            })
        }
        else {
            this.unauthorize_access();
        }

    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(reportPermissions.includes("choice_emi_transaction")===false ){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    refressOnDateChange(){
        this._getCategory();
        this._getBrand();
        this._getModel('');
        //this._getEmiScheme();
        this._getTenure();
        //this._getEmiIssure();
        //this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID);
        this.setState({
            subventionValue:[],
            subventionIDs:'',
            categoryValue:[],
            categoryIDs:'',
            brandValue:[],
            brandsIDs:'',
            modelValue:[],
            modelIDs:'',
            // emiSchemeValue:null,
            // emiSchemeIDs:'',
            tenureValue:[],
            tenureIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            // ciutidValue: [],
            // ciutidIds: '',
        });
    }
    changeProductType(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        var is_enable = compareValues(value, this.state.active_product);
        this.setState({
            productTypeIDs:value,
            productTypeValue:optionSelected,
            isChange: is_enable
        });
    }
    changeServiceType(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;

        this.setState({
            serviceTypeIDs:value,
            serviceTypeValue:optionSelected,
            isChange: true
        });
    }
    get_merchant_by_acq(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/reports/get-acq-merchant-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = [];
                var mVal = [];
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                    mVal.push(merchant.merchant_code);
                });
                this.setState({
                    merchantList:mList,
                    acq_m_list:mList,
                    is_merchant_loading: false
                })
            }
        });
    }
    get_filtered_emi_transaction_report(object_type, object_code, event) {
        var that = this;
        var corCol = 'Merchant';
        var ufeCol = 'Merchant';
        if(that.state.txnTypeIDs.includes("FAILED")===true) {
            corCol = 'Co Reason Message';
            ufeCol = 'Ufe Message';
        }
        var pos_order_id = 'Merchant';
        var grab_order_id = 'Merchant';
        var grab_client_id = 'Merchant';
        var pos_merchant = 'Merchant';
        if(that.state.is_posbillinput==1){
            grab_order_id = 'Grab Order ID';
            pos_order_id = 'Pos Order ID';
            grab_client_id = 'Grab Client ID';
            pos_merchant = 'Pos Merchant ID';
        }
        disabledBody()
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        var acqBank = this.state.acqBankIds;
        var emiIssuer = this.state.emiIssuerIDs;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        if(object_type==='Acquiring Bank' && this.state.storeID===''){
            acqBank = object_code;
        }
        if(object_type==='Issuing Bank' && this.state.storeID===''){
            emiIssuer = object_code;
        }
        this.setState({
            active_mids: merchants,
            active_cids: chains,
            active_sids: stores,
            active_bids: acqBank,
            active_cityids: this.state.cityIds,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
            active_metric: this.state.metric,
            active_is_void: this.state.is_void,
            active_subventionIDs: this.state.subventionIDs,
            active_categoryIDs: this.state.categoryIDs,
            active_brandIDs: this.state.brandIDs,
            active_modelIDs: this.state.modelIDs,
            active_emiSchemeIDs: this.state.emiSchemeIDs,
            active_tenureIDs: this.state.tenureIDs,
            active_emiIssuerIDs: emiIssuer,
            active_transaction_type: this.state.txnTypeIDs,
            active_utid: this.state.ciutidIds,
            active_is_settled: this.state.isSettledIDs,
            active_is_prim_id: this.state.is_prim_id,
            active_is_posbillinput: this.state.is_posbillinput,
        })

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: acqBank,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            metric: this.state.metric,
            is_void: this.state.is_void,
            txn_type: 'EMI',
            subventionIDs: this.state.subventionIDs,
            categoryIDs: this.state.categoryIDs,
            brandIDs: this.state.brandIDs,
            modelIDs: this.state.modelIDs,
            emiSchemeIDs: this.state.emiSchemeIDs,
            tenureIDs: this.state.tenureIDs,
            emiIssuerIDs: emiIssuer,
            transaction_type: this.state.txnTypeIDs,
            utid: this.state.ciutidIds,
            is_settled: this.state.isSettledIDs,
            is_posbillinput: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            product_type: this.state.productTypeIDs,
            service_type: this.state.serviceTypeIDs

        };
        if ($.fn.DataTable.isDataTable('#EmiTraTable')) {
            $('#EmiTraTable').DataTable().clear().destroy();
        }
        var EmiTraTable = $('#EmiTraTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/transaction-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody()
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"Merchant", "width":"150px"},
                    {"data":"Chain", "width":"100px"},
                    {"data":"Store Name", "width":"100px"},
                    {"data":"Store Address 1", "width":"100px"},
                    {"data":"Store Address 2", "width":"100px"},
                    {"data":"City"},
                    {"data":"Amount"},
                    {"data": "echargeslip_url"},
                    {"data":"Transaction Date"},
                    {"data":"Transaction Time"},
                    {"data":"Btid"},
                    {"data":"Utid"},
                    {"data": "Card Number"},
                    {"data": "Acquirer Bank"},
                    {"data":"Issuer Bank"},
                    {"data":"Scheme"},
                    {"data":"Card Grade"},
                    {"data":"Card Type"},
                    {"data":"RRN No"},
                    {"data":"Approval Code"},
                    {"data":"Merchant Id"},
                    {"data":"Merchant Invoice Number"},
                    {"data":"Batchsrl"},
                    {"data":"Invoice"},
                    {"data": "Bank Merchant Id"},
                    {"data":"Processing Code"},
                    {"data":"Transaction Type"},
                    {"data":"Card Holder Name"},
                    {"data":"Tenure"},
                    {"data":"Subvention"},
                    {"data":"Brand"},
                    {"data":"Issuer"},
                    {"data":"Category"},
                    {"data":"Scheme Name"},
                    {"data":"Model"},
                    {"data":"Cashback Amount"},
                    {"data":"Rate of Interest"},
                    {"data":"Innoviti Subvention"},
                    {"data":"Merchant Subvention"},
                    {"data":"Brand Subvention"},
                    {"data":"Bank Subvention"},
                    {"data":"Settlement Date"},
                    {"data":"Settled/Unsettled"},
                    {"data":corCol},
                    {"data":ufeCol},
                    {"data":grab_order_id },
                    {"data":pos_order_id },
                    {"data":grab_client_id },
                    {"data":pos_merchant },
                    {"data":"prim_id" },
                    {"data":"parent_prim_id"},
                    {"data":"Bin No" },
                    {"data":"EMI Bank Code"},
                    {"data":"State"}
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                        },
                        "width": "80px",
                        "targets": 8
                    },
                    {
                        render: function (data, type, row) {
                            return '<td ><a href="#" data-code ="' + data + '" data-trdate ="' + row['Transaction Date'] + '" data-acqbank ="' + row['Acquirer Bank'] + '" data-primid ="' + row['prim_id'] + '">Get Receipt</a> &nbsp;</td>';
                        },
                        className: "charge_slip",
                        targets: 7,
                        aTargets: [-1]
                    },
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2]
                    },
                ],
            });
        if(that.state.txnTypeIDs.includes("FAILED")===true) {
            EmiTraTable.columns(7).visible(false);
            EmiTraTable.columns(43).visible(true);
            EmiTraTable.columns(44).visible(true);
        } else {
            EmiTraTable.columns(7).visible(true);
            EmiTraTable.columns(43).visible(false);
            EmiTraTable.columns(44).visible(false);
        }
        if(that.state.is_posbillinput===1) {
            EmiTraTable.columns(45).visible(true);
            EmiTraTable.columns(46).visible(true);
            EmiTraTable.columns(47).visible(true);
            EmiTraTable.columns(48).visible(true);
        } else {
            EmiTraTable.columns(45).visible(false);
            EmiTraTable.columns(46).visible(false);
            EmiTraTable.columns(47).visible(false);
            EmiTraTable.columns(48).visible(false);
        }
        if(that.state.is_prim_id===1) {
            EmiTraTable.columns(49).visible(true);
            if(that.state.txnTypeIDs.includes("REVERSAL")===true || that.state.txnTypeIDs.includes("VOID")===true || that.state.txnTypeIDs.includes("FAILED")===true|| that.state.txnTypeIDs.includes("all")===true) {
                EmiTraTable.columns(50).visible(true);
            } else {
                EmiTraTable.columns(50).visible(false);
            }
        } else {
            EmiTraTable.columns(49).visible(false);
            EmiTraTable.columns(50).visible(false);
        }

        $('#EmiTraTable').on('click', 'td.charge_slip a', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var code = $(this).data("code");
            var acqbank = $(this).data("acqbank");
            var trdate = $(this).data("trdate");
            var prim_id = $(this).data("primid");
            let win=window.open('about:blank','popUpWindow', 'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes' )
            var perLoad = '<div style="text-align: center" id="loaderDiv"><img src=" '+ loadingGif +' "></div>';
            win.document.write(perLoad)
            $.ajax({
                url:config.get('API_URL')+ "/reports/generate_slip/?code="+code+"&acq_bank_name="+acqbank+"&transaction_date="+trdate+"&prim_id="+prim_id,
                type: 'GET',

                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                success: function (response) {
                    win.document.close();
                    win.document.write(response)
                },
                //dataType: 'html'
            })
        })

    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }
        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        var is_enable = compareValues(midArray, this.state.active_mids);
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable,
            search_code: midArray,
            search_type:'merchant',
            storeObject:[],
            search_object_code: this.state.object_code,
        });
        // this.get_filtered_emi_transaction_report(midArray, '', '', this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, '', this.state.isSettledIDs);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code,false,'');
        }
        this.ci_utid(midArray, '','',false,'');
    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                    this.state.chainList.move(index,0).join(',');
                }
            });
        }
        var is_enable = compareValues(cidArray, this.state.active_cids);
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable,
            search_code: cidArray,
            search_type:'chain',
            storeObject:[],
            search_object_code: this.state.merchantID,
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, cidArray, '', this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, '', this.state.isSettledIDs);

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID,false,'');
        }
        this.ci_utid(this.state.merchantID, cidArray, '',false,'');
    }
    getChain(code, type, object_type, object_code){
        this.setState({
            chainList:[],
            is_chain_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                is_chain_loading: false
            })
        });
    }
    getStore(code, type, object_type, object_code,is_search, search_value) {
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.storeObject
        }
        this.setState({
            storeList:[],
            is_store_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-batch-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code,
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            //this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            let res = []
            if (Array.isArray(this.state.storeID) && this.state.storeID) {
                const uniq = new Set(storeList.map(e => JSON.stringify(e)));

                storeList = Array.from(uniq).map(e => JSON.parse(e));

            }
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }
    changeStore(login_type, store_object, checked_item, e) {
        if (login_type === 'store') {
            let value='';
            let sidArray = [];
            if(store_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                store_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            var is_enable = compareValues(sidArray, this.state.active_sids);
            this.setState({
                storeID: sidArray,
                storeValue:store_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: is_enable
            });
        } else {
            let item_list = this.state.storeID;
            let item_list_object = this.state.storeObject;
            let checked_list = store_object.value;
            let checked_list_object = store_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [store_object, ...this.state.storeList.filter(item => item !== store_object)];
                this.setState({
                    storeID: [...this.state.storeID,  store_object.value],
                    storeObject: [...this.state.storeObject, store_object],
                    isChange: true,
                    storeList: newData,
                    ciutidIds: '',
                    ciutidValue: [],
                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        storeID: item_list,
                        isChange: true,
                        ciutidIds: '',
                        ciutidValue: [],
                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        storeObject: item_list_object,
                        isChange: true
                    })
                }
            }
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }

        setTimeout(function() {
            this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, false, '');
        }.bind(this), 200);
    }
    storeToggleList() {
        this.setState({
            storeListOpen: !this.state.storeListOpen,
        });
    }
    storeFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getStore(this.state.search_code, this.state.search_type, this.state.object_type, this.state.search_object_code,true, value);
        }.bind(this), 200);
    }
    closeStoreList() {
        this.setState({
            storeListOpen: false,
        });
    }
    _get_acq_banks() {
        axios.get(config.get('API_URL')+'/reports/acq-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading: false
        })
    }

    change_acq_banks(optionSelected){ //console.log(optionSelected);
        let value='';
        let acqBankArray = [];
        if(optionSelected.length<1){
            value = null;
            acqBankArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        var is_enable = compareValues(acqBankArray, this.state.active_bids);
        this.setState({
            acqBankIds:acqBankArray,
            acqBankValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs);
    }
    _get_city(){
        axios.get(config.get('API_URL')+'/reports/get-city/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((city, index) => {
                    this.state.cityLists.push({value: city.city_name, label: city.city_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    changeCity(optionSelected){
        let value='';
        let cityArray = [];
        if(optionSelected.length < 1){
            value = null;
            cityArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                cityArray.push(mids.value)
                var index = this.state.cityLists.findIndex(obj => obj.value==mids.value);
                this.state.cityLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(cityArray, this.state.active_cityids);
        this.setState({
            cityIds:cityArray,
            cityValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, cityArray,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)
    }
    _get_issuing_banks(){
        axios.get(config.get('API_URL')+'/reports/all_emi_issuing_banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuBank, index) => {
                    this.state.issuerBankList.push({value: issuBank.emi_bank_code, label: issuBank.issuer_bank_display_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    _getCategory(){
        axios.post(config.get('API_URL')+'/reports/get-emi-category/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.setState({
                categoryLists:[]
            })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((category, index) => {
                    this.state.categoryLists.push({value: category.category, label: category.category})
                });
            }
        });
    }
    changeCategory(optionSelected){
        let value='';
        let catArray = [];
        if(optionSelected.length < 1){
            value = null;
            catArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                catArray.push(mids.value)
                var index = this.state.categoryLists.findIndex(obj => obj.value==mids.value);
                this.state.categoryLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(catArray, this.state.active_categoryIDs);
        this.setState({
            categoryIDs:catArray,
            categoryValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, catArray, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)
    }


    _getBrand(){
        axios.post(config.get('API_URL')+'/reports/get-emi-brand/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    brandLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((brand, index) => {
                    this.state.brandLists.push({value: brand.brand, label: brand.brand})
                });
            }
        });
    }
    changeBrand(optionSelected){
        let value='';
        let brandArray = [];
        if(optionSelected.length < 1){
            value = null;
            brandArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                brandArray.push(mids.value)
                var index = this.state.brandLists.findIndex(obj => obj.value==mids.value);
                this.state.brandLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(brandArray, this.state.active_brandIDs);
        this.setState({
            brandIDs:brandArray,
            brandValue:optionSelected,
        });
        this.setState({
            modelLists:[],
            modelValue:null,
            modelIDs:'',
            isChange: is_enable
        })
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, brandArray, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)
        this._getModel(brandArray);
    }
    _getModel(brandArray){
        axios.post(config.get('API_URL')+'/reports/get-emi-model/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
                brandArray: brandArray
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    modelLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((model, index) => {
                    this.state.modelLists.push({value: model.model, label: model.model})
                });
            }
        });
    }
    changeModel(optionSelected){
        let value='';
        let modelArray = [];
        if(optionSelected.length < 1){
            value = null;
            modelArray= '';
        }
        else{
            optionSelected.map((mids, i) => {
                modelArray.push(mids.value)
                var index = this.state.modelLists.findIndex(obj => obj.value==mids.value);
                this.state.modelLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(modelArray, this.state.active_modelIDs);
        this.setState({
            modelIDs:modelArray,
            modelValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, modelArray, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)
    }

    _getEmiScheme(){
        axios.post(config.get('API_URL')+'/reports/get-emi-scheme-filter/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((scheme, index) => {
                    this.state.emiSchemeLists.push({value: scheme.issuer_scheme_code, label: scheme.issuer_scheme_name})
                });
            }
        });
    }
    changeEmiScheme(optionSelected){
        let value='';
        let schemeArray = [];
        if(optionSelected.length < 1){
            value = null;
            schemeArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                schemeArray.push(mids.value)
                var index = this.state.emiSchemeLists.findIndex(obj => obj.value==mids.value);
                this.state.emiSchemeLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(schemeArray, this.state.active_emiSchemeIDs);
        this.setState({
            emiSchemeIDs:schemeArray,
            emiSchemeValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, schemeArray, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)
    }

    _getTenure(){
        axios.post(config.get('API_URL')+'/reports/get-emi-tenure/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    tenureLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((Tenure, index) => {
                    this.state.tenureLists.push({value: Tenure.tenure, label: Tenure.tenure})
                });
            }
        });
    }
    changeTenure(optionSelected){
        let value='';
        let tenureArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenureArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                tenureArray.push(mids.value)
                var index = this.state.tenureLists.findIndex(obj => obj.value==mids.value);
                this.state.tenureLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(tenureArray, this.state.active_tenureIDs);
        this.setState({
            tenureIDs:tenureArray,
            tenureValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.schemeIDs, tenureArray, this.state.emiIssuerIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)
    }

    _getEmiIssure(){
        axios.get(config.get('API_URL')+'/reports/all_emi_issuing_banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
                this.setState({
                    emiIssuerLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuer, index) => {
                    this.state.emiIssuerLists.push({value: issuer.emi_bank_code, label: issuer.issuer_bank_display_name})
                });
            }
        });
    }
    changeEmiIssuer(login_type, optionSelected){
        let value='';
        let emiIssuerArray = [];
        if(optionSelected.length < 1){
            value = null;
            emiIssuerArray= '';
        }
        else{
            optionSelected.map((mids, i) => {
                if(login_type=='Issuing Bank'){
                    emiIssuerArray.push(mids.value)
                }
                else {
                    emiIssuerArray.push(mids.value)
                    var index = this.state.emiIssuerLists.findIndex(obj => obj.value == mids.value);
                    this.state.emiIssuerLists.move(index, 0).join(',');
                }
            });
        }
        var is_enable = compareValues(emiIssuerArray, this.state.active_emiIssuerIDs);
        this.setState({
            emiIssuerIDs:emiIssuerArray,
            emiIssuerValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, emiIssuerArray, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)
    }
    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY'),

        });
         if(event.type=='apply'){
             var is_date_change = false;
             if(this.state.active_yestSend==this.state.yestSend && this.state.active_todSend==this.state.todSend){
                 is_date_change = false;
             } else {
                 is_date_change = true;
             }
             this.setState({
                 isChange: is_date_change
             })
        //     this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //         this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)
            this.refressOnDateChange();

        }
    }
    handleCheckVoid(e)
    {
        var is_void = 1;
        if(e.target.checked===true){
            this.setState({ is_void:1})
        } else {
            this.setState({ is_void:0});
            is_void = 0;
        }
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)

    }
    handleSubvention = (optionSelected,subventionIDs) =>{
        this.setState({
            subventionValue: optionSelected ,
            isChange: true,
            subventionIDs:subventionIDs,
        })
    }
    handleTxnType = (optionSelected, txnTypeIDs) =>
    {
        this.setState({
            txnTypeIDs:txnTypeIDs,
            txnTypeValue:optionSelected,
            isChange: true
        });
    }
    handleSettled = (optionSelected, isSettledIDs) =>
    {
        this.setState({
            isSettledIDs:isSettledIDs,
            isSettledValue:optionSelected,
            isChange: true
        });
    }
    ci_utid(mid,cid,sid,is_search, search_value) {
        let utidList = [];
        let selected_val = '';
        if(is_search===true){
            selected_val = this.state.ciutidIds
        }
        this.setState({
            ciutidList: [],
            is_utid_loading: true
        })
        axios.post(config.get('API_URL') + '/reports/get-utid/', {

                mid: mid,
                cid: cid,
                sid: sid,
                is_search:is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {

            if (Array.isArray(response.data) && response.data.length) {
                response.data.map((ci_utid, index) => {
                    utidList.push(ci_utid.utid)
                });
                if (Array.isArray(this.state.ciutidIds) && this.state.ciutidIds) {
                    utidList = utidList.filter( ( el ) => !this.state.ciutidIds.includes( el ) );
                    this.state.ciutidIds.map((ut,index) => {
                        utidList = [ut, ...utidList.filter(item => item !== ut)];
                    })

                }
                this.setState({
                    ciutidList: utidList,
                    is_utid_loading: false
                })

            } else {

                this.setState({
                    ciutidList: [],
                    is_utid_loading: false
                })
            }

        });
    }
    filterList(e){

        var value = e.target.value
        setTimeout(function() {
            this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, true, value);
        }.bind(this), 200);
    }
    toggleList() {
        this.setState({
            listOpen: !this.state.listOpen,
        });
    }

    changeUtid(utid,checked_item, e){
        let item_list = this.state.ciutidIds
        let checked_list = utid;
        //console.log(checked_list);
        if(checked_item===false) {
            const newData = [utid, ...this.state.ciutidList.filter(item => item !== utid)];
            this.setState({
                ciutidIds: [...this.state.ciutidIds,  utid],
                isChange: true,
                ciutidList: newData
            });

        } else{
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                if(item_list.length<1) {
                    item_list='';
                }
                this.setState({
                    ciutidIds: item_list,
                    isChange: true
                })
            }
        }


        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }
    transactionReportDownload (e){
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');
        if(days_beet>config.get('REPORT_CSV_DAYS_LIMIT')) {
            alert("Date range too large. Please select a date range of "+ config.get('REPORT_CSV_DAYS_LIMIT')+ " days at a time");
            return false;
        }
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            metric: this.state.metric,
            is_void: this.state.is_void,
            download: true,
            txn_type: 'EMI',
            subventionIDs: this.state.subventionIDs,
            categoryIDs: this.state.categoryIDs,
            brandIDs: this.state.brandIDs,
            modelIDs: this.state.modelIDs,
            emiSchemeIDs: this.state.emiSchemeIDs,
            tenureIDs: this.state.tenureIDs,
            emiIssuerIDs: this.state.emiIssuerIDs,
            transaction_type: this.state.txnTypeIDs,
            utid: this.state.ciutidIds,
            is_settled: this.state.isSettledIDs,
            is_posbillinput: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            product_type: this.state.productTypeIDs,
            service_type: this.state.serviceTypeIDs
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/transaction-reports-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'emi_transaction_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    handleCheckPosBill(e) {
        var is_posbillinput = 1;
        if (e.target.checked === true) {
            this.setState({is_posbillinput: 1, isChange: true})

        } else {
            this.setState({is_posbillinput: 0, isChange: true});
            is_posbillinput = 0;
            // EodTraTable.columns(36).visible(false);
        }
        var is_enable = compareValues(is_posbillinput, this.state.active_is_posbillinput);
        this.setState({
            isChange: is_enable
        })

    }

    handleCheckPrimId(e) {
        var is_prim_id = 1;
        if (e.target.checked === true) {
            this.setState({is_prim_id: 1, isChange: true})

        } else {
            this.setState({is_prim_id: 0, isChange: true});
            is_prim_id = 0;
            //EodTraTable.columns(36).visible(false);
        }
        var is_enable = compareValues(is_prim_id, this.state.active_is_prim_id);
        this.setState({
            isChange: is_enable
        })

    }
    reset_all(e){
        this.refs.subventionFilter.resetSubventionFilter();
        this.refs.txnTypeFilter.resetTxnTypeFilter();
        this.refs.settledFilter.resetSettledFilter();
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            subventionValue:[],
            subventionIDs:'',
            categoryValue:[],
            categoryIDs:'',
            brandValue:[],
            brandIDs:'',
            modelValue:[],
            modelIDs:'',
            emiSchemeValue:[],
            emiSchemeIDs:'',
            tenureValue:[],
            tenureIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            storeValue:[],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],

            ciutidValue: [],
            ciutidIds: '',

            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            serviceTypeIDs: '',
            serviceTypeValue: {value: '', label: 'All'},
            productTypeIDs: '',
            productTypeValue: {value: '', label: 'All'},
        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "32px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "35px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        const utid_lists = this.state.ciutidList.map((utid_object, index) => {
            var chk_input = <input type='checkbox' checked={false}/>
            var activeCls = 'dd-list-item';
            var checked_item = false;
            if(this.state.ciutidIds.includes(utid_object) === true){
                chk_input = <input type='checkbox' checked={true}/>
                activeCls = "dd-list-item dd-list-active";
                checked_item = true;
            }
            return (
                <li key={index} className={activeCls} onClick={this.changeUtid.bind(this, utid_object,checked_item)}>
                    {chk_input}
                    &nbsp;&nbsp;{utid_object}
                </li>
            )
        })
        const store_lists = this.state.storeList.map((store_object, index) => {
            // console.log("store_object");
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.storeID.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeStore.bind(this, '', store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })
        return(
           
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Choice EMI Transaction Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-10 filter-border-right">
                                    <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                        <div><label> Date Filter: </label></div>
                                        <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                         onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}>
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                            <input type="text" name="dateRange" className="form-control dateRangeInput"
                                                   value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                        </DateRangePicker>
                                    </div>
                                    {this.state.merchant_list_box ===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Merchants</label>
                                            <ReactMultiSelectCheckboxes name="merchants"
                                                isMulti
                                                isLoading={this.state.is_merchant_loading}
                                                value={this.state.merchantValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeMerchant.bind(this,'')}
                                                options={this.state.merchantList}
                                                placeholderButtonLabel="Select [Merchant]"
                                            />

                                            <div className="clearfix"></div>
                                        </div> : null}
                                    {this.state.chain_list_box===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Chain </label>
                                            <ReactMultiSelectCheckboxes name="chain"
                                                isMulti
                                                                        isLoading={this.state.is_chain_loading}
                                                components={{ MenuList }}
                                                value={this.state.chainValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeChain.bind(this,'')}
                                                options={this.state.chainList}
                                                placeholderButtonLabel="Select [Chain]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>: null }
                                    {this.state.store_list_box===true?
                                        <div className="col-md-2 filter-bottom5 padd-5" >
                                            <label> Store: </label>
                                            <div className="dd-wrapper">
                                                <div className="dd-header" onClick={() => this.storeToggleList()}>
                                                    {this.state.storeID==''?
                                                        <div className="dd-header-title">{this.state.storeHeaderTitle}</div>:
                                                        <div className="dd-header-title">{this.state.storeID.length} Selected</div>
                                                    }

                                                    <i className="fa fa-angle-down"></i>
                                                </div>
                                                {this.state.storeListOpen ===true?
                                                    <div
                                                        role="list"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <input
                                                            className="dd-list-search-bar"
                                                            placeholder="Search"
                                                            onChange={(e) => this.storeFilterList(e)}
                                                        />
                                                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                        {/*<div className="dd-scroll-list">*/}
                                                        <ul className="dd-list">
                                                            {this.state.is_store_loading===true?
                                                                <li>
                                                                    <BeatLoader
                                                                        css={override}
                                                                        sizeUnit={"px"}
                                                                        size={5}
                                                                        color={'#666666'}
                                                                        loading={this.state.is_store_loading}
                                                                    />
                                                                </li>: null}
                                                            {store_lists}

                                                        </ul> </div>: null }
                                                {/*</div>*/}
                                            </div>
                                            <div className="clearfix"></div>
                                        </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <div className="dd-wrapper">
                                                    <div className="dd-header" onClick={() => this.toggleList()}>
                                                        {this.state.ciutidIds==''?
                                                            <div className="dd-header-title">{this.state.headerTitle}</div>:
                                                            <div className="dd-header-title">{this.state.ciutidIds.length} Selected</div>
                                                        }

                                                        <i className="fa fa-angle-down"></i>
                                                    </div>
                                                    {this.state.listOpen ===true?
                                                        <div
                                                            role="list"
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <input
                                                                className="dd-list-search-bar"
                                                                placeholder="Search"
                                                                onChange={(e) => this.filterList(e)}
                                                            />
                                                            <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                            {/*<div className="dd-scroll-list">*/}
                                                            <ul className="dd-list">
                                                                {this.state.is_utid_loading===true?
                                                                    <li>
                                                                        <BeatLoader
                                                                            css={override}
                                                                            sizeUnit={"px"}
                                                                            size={5}
                                                                            color={'#666666'}
                                                                            loading={this.state.is_utid_loading}
                                                                        />
                                                                    </li>: null}
                                                                {utid_lists}

                                                            </ul> </div>: null }
                                                    {/*</div>*/}
                                                </div>
                                                <div className="clearfix"></div>
                                            </div>
                                    {this.state.acq_bank_list_box===true?
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label>Acquirer:</label>
                                        <ReactMultiSelectCheckboxes name="acqurier"
                                            isMulti
                                            value={this.state.acqBankValue}
                                            styles={customStyles} className="report-listbox"
                                            isClearable={false}
                                            onChange={this.change_acq_banks.bind(this)}
                                            options={this.state.acqBankList}
                                            placeholderButtonLabel="Select [Acquirer]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    : null }
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Subvention </label>
                                        <SubventionFilter  ref="subventionFilter" onSelectSubvention = {this.handleSubvention} />
                                        <div className="clearfix"></div>

                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Category </label>
                                        <ReactMultiSelectCheckboxes name="category"
                                                isMulti
                                                value={this.state.categoryValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeCategory.bind(this)}
                                                options={this.state.categoryLists}
                                                placeholderButtonLabel="Select [Category]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>


                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label>Brand:</label>
                                        <ReactMultiSelectCheckboxes name="brand"
                                                isMulti
                                                value={this.state.brandValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeBrand.bind(this)}
                                                options={this.state.brandLists}
                                                placeholderButtonLabel="Select [Brand]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Model: </label>
                                        <ReactMultiSelectCheckboxes name="model"
                                                isMulti
                                                value={this.state.modelValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeModel.bind(this)}
                                                options={this.state.modelLists}
                                                placeholderButtonLabel="Select[Model]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> EMI Scheme: </label>
                                        <ReactMultiSelectCheckboxes name="emi_scheme"
                                                isMulti
                                                value={this.state.emiSchemeValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeEmiScheme.bind(this)}
                                                options={this.state.emiSchemeLists}
                                                placeholderButtonLabel="Select [ EMI Scheme]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Tenure: </label>
                                        <ReactMultiSelectCheckboxes name="tenure"
                                                                    isMulti
                                                value={this.state.tenureValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeTenure.bind(this)}
                                                options={this.state.tenureLists}
                                                placeholderButtonLabel="Select [Tenure]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    {this.state.issuer_bank_list_box==true?
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> EMI Issuer: </label>
                                        <ReactMultiSelectCheckboxes name="emi_issure"
                                                isMulti
                                                components={{ MenuList }}
                                                value={this.state.emiIssuerValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeEmiIssuer.bind(this,'')}
                                                options={this.state.emiIssuerLists}
                                                placeholderButtonLabel="Select [EMI Issuer]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>: null}

                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Txn Type </label>
                                        <TxnTypeFilter ref="txnTypeFilter" onSelectTxnType = {this.handleTxnType} is_upi_leg1 = 'No' />
                                        <div className="clearfix"></div>
                                        <div className="clearfix"></div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Settled/Unsettled </label>
                                        <SettledUnsettledFilter ref="settledFilter" onSelectSettled = {this.handleSettled}/>
                                        <div className="clearfix"></div>
                                    </div>
                                            {this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Product Type </label>
                                                    <Select name="product_type"

                                                            value={this.state.productTypeValue}
                                                            styles={customStyles} className="report-listbox"
                                                            isClearable={false}
                                                            onChange={this.changeProductType.bind(this)}
                                                            options={this.state.productTypeLists}
                                                            placeholder="[Product Type]"
                                                    />
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                            {this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Service Type </label>
                                                    <Select name="service_type"

                                                            value={this.state.serviceTypeValue}
                                                            styles={customStyles} className="report-listbox"
                                                            isClearable={false}
                                                            onChange={this.changeServiceType.bind(this)}
                                                            options={this.state.serviceTypeLists}
                                                            placeholder="[Service Type]"
                                                    />
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                    {/*<div className="col-md-3 padd30 col-md-2 filter-bottom5 padd-5">*/}
                                    {/*    <label><input type="checkbox" name="is_void"*/}
                                    {/*                  onChange={this.handleCheckVoid.bind(this)}*/}
                                    {/*                  checked={(this.state.is_void == 1) ? true : false}/> &nbsp; Show*/}
                                    {/*        prim id</label>*/}
                                    {/*</div>*/}
                                        </div>
                                        <div className="col-md-2 filter-bottom5 ">
                                            <div className="top-margin-30"><label><input type="checkbox" name="is_posbillinput"
                                                               onChange={this.handleCheckPosBill.bind(this)}
                                                               checked={(this.state.is_posbillinput == 1) ? true : false}/> &nbsp;  POSBILLINPUT</label></div>
                                            <div><label><input type="checkbox" name="is_prim_id"
                                                               onChange={this.handleCheckPrimId.bind(this)}
                                                               checked={(this.state.is_prim_id == 1) ? true : false}/> &nbsp;  Prim ID</label></div>


                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }

                                        <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_emi_transaction_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>&nbsp; &nbsp;
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>

                                    </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.transactionReportDownload.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="EmiTraTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th width="150px">Merchant</th>
                                                <th width="100px">Chain</th>
                                                <th width="100px">Store Name</th>
                                                <th width="100px">Store Address 1</th>
                                                <th width="100px">Store Address 2</th>
                                                <th>City</th>
                                                <th>Amount</th>
                                                <th>Digital Chargeslip</th>
                                                <th>Transaction Date</th>
                                                <th>Transaction Time</th>
                                                <th>Btid</th>
                                                <th>Utid</th>
                                                <th>Card Number</th>
                                                <th>Acquirer Bank</th>
                                                <th>Issuer Bank</th>
                                                <th>Scheme</th>
                                                <th>Card Grade</th>
                                                <th>Card Type</th>
                                                <th>RRN No</th>
                                                <th>Approval Code</th>
                                                <th>Merchant Id</th>
                                                <th>Merchant Invoice Number</th>
                                                <th>Batchsrl</th>
                                                <th>Invoice</th>
                                                <th>Bank Merchant Id</th>
                                                <th>Processing Code</th>
                                                <th>Transaction Type</th>
                                                <th>Card Holder Name</th>
                                                <th>Tenure</th>
                                                <th>Subvention</th>
                                                <th>Brand</th>
                                                <th>Issuer</th>
                                                <th>Category</th>
                                                <th>Scheme Name</th>
                                                <th>Model</th>
                                                <th>Cashback Amount</th>
                                                <th>Rate of Interest</th>
                                                <th>Innoviti Subvention</th>
                                                <th>Merchant Subvention</th>
                                                <th>Brand Subvention</th>
                                                <th>Bank Subvention</th>
                                                <th>Settlement Date</th>
                                                <th>Settled/Unsettled</th>
                                                <th>Co Reason Message</th>
                                                <th width="150">Ufe Message</th>
                                                <th>Grab Order ID</th>
                                                <th>Pos Order ID</th>
                                                <th>Grab Client ID</th>
                                                <th>Pos Merchant ID</th>
                                                <th>Prim ID</th>
                                                <th>Parent Prim ID</th>
                                                <th>Bin No</th>
                                                <th>EMI Bank Code</th>
                                                <th>State</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating CSV...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      
         );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(ChoiceEmiTransactionReport);